import {
  ActionProvider,
  DataProvider,
  EventConfigProvider,
} from "../../Components";
import { Templates } from "./Components/Templates";
import { SharingMeta } from "./Components/SharingMeta";
import { HelmetProvider } from "react-helmet-async";
import { Helmet } from "react-helmet";
import { Tracking } from "../../Components/Tracking";

export const Event = () => {
  return (
    <EventConfigProvider>
      <DataProvider>
        <SharingMeta />
        <ActionProvider>
          <Tracking>
            <Templates />
          </Tracking>
        </ActionProvider>
      </DataProvider>
    </EventConfigProvider>
  );
};
